<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">Benefício: #{{ $route.params.id }}</h1>
    </div>

    <load v-if="loading" />

    <div v-else class="col-md-12">
      <div class="card mb-0 shadow">
        <div v-if="historicoStatus == false" class="card-body">
          <div class="row">
            <form-input
              grid="6"
              v-model="beneficio.nome"
              label="Nome"
              :required="true"
            />

            <form-select
              grid="6"
              v-model="beneficio.fonte_recurso"
              label="Fonte do Recurso orçamentário"
              :itens="$root.arrays.beneficio_fonte"
              :required="true"
            />

            <form-select
              grid="4"
              v-model="beneficio.tipo_id"
              label="Tipo"
              :itens="tipos"
              :required="true"
              @input="getSubTipos"
            />

            <form-select
              grid="4"
              v-model="beneficio.subtipo_id"
              label="Subtipo"
              :itens="subtipos"
              :required="true"
              :disabled="subtipos.length == 0"
            />

            <form-input
              grid="4"
              v-model="beneficio.quantidade"
              label="Quantidade"
            />

            <form-calendar-range
              grid="4"
              v-model="beneficio.periodo"
              label="Período Inicial e Final"
            />

            <form-input
              grid="4"
              v-model="beneficio.idade_minima"
              label="Idade Mínima"
            />

            <form-input
              grid="4"
              v-model="beneficio.idade_maxima"
              label="Idade Máxima"
            />

            <form-select
              grid="4"
              v-model="beneficio.sexo"
              label="Sexo"
              :itens="$root.arrays.beneficio_sexo"
            />

            <form-select
              grid="4"
              v-model="beneficio.categoria"
              label="Categoria"
              :itens="$root.arrays.beneficio_categoria"
              :required="true"
            />

            <form-input
              v-show="mostrarValor"
              grid="4"
              v-model="beneficio.valor"
              label="Valor R$"
              @input="formatarValor"
            />

            <form-select
              grid="4"
              v-model="beneficio.status"
              label="Status"
              :itens="status_beneficio"
              :required="true"
              @change="verificarStatus"
            />

            <form-select
              grid="8"
              v-model="beneficio.unidades"
              label="Unidade"
              :itens="unidades"
              :required="true"
              :multiple="true"
            />

            <form-textarea
              v-model="beneficio.descricao"
              label="Observação"
              :required="true"
            />

            <form-toggle
              grid="12"
              mt="0"
              v-model="beneficio.is_itens"
              label="Possui Itens?"
            />
          </div>

          <div v-if="Number(beneficio.is_itens) === 1">
            <!-- Itens já existentes no banco -->
            <div v-for="item in beneficio.itens" :key="item.id">
              <div class="row px-md-2">
                <form-input
                  grid="3"
                  class="px-md-1"
                  v-model="item.nome"
                  label="Nome"
                  :required="true"
                />

                <form-input
                  grid="2"
                  class="px-md-1"
                  v-model="item.quantidade"
                  label="Qtd"
                  :required="true"
                />

                <form-input
                  grid="2"
                  class="px-md-1"
                  v-model="item.dimensoes"
                  label="Dimensão"
                  :required="true"
                />

                <form-input
                  grid="2"
                  class="px-md-1"
                  v-model="item.peso"
                  label="Peso"
                  :required="true"
                />

                <form-calendar
                  grid="2"
                  class="px-md-1"
                  v-model="item.validade"
                  label="Validade"
                  :required="true"
                />

                <div v-if="edit" class="col-sm-12 col-md-1 px-md-1">
                  <a
                    class="col btn btn-danger btn-sm mt-4"
                    @click="excluirItem(item)"
                  >
                    <i class="col mdi mdi-close px-0"></i>
                  </a>
                </div>
              </div>
            </div>

            <!-- Novos itens ainda não salvos -->
            <div v-for="(_, index) in count" :key="`novo-item-${index}`">
              <div class="row px-md-2">
                <form-input
                  grid="3"
                  class="px-md-1"
                  v-model="item_nome[index]"
                  label="Nome"
                  :required="true"
                />

                <form-input
                  grid="2"
                  class="px-md-1"
                  v-model="item_quantidade[index]"
                  label="Qtd"
                  :required="true"
                />

                <form-input
                  grid="2"
                  class="px-md-1"
                  v-model="item_dimensoes[index]"
                  label="Dimensões"
                />

                <form-input
                  grid="2"
                  class="px-md-1"
                  v-model="item_peso[index]"
                  label="Peso"
                />

                <form-input
                  grid="2"
                  class="px-md-1"
                  v-model="item_validade[index]"
                  label="Validade"
                />

                <div
                  v-if="index < count - 1"
                  class="col-sm-12 col-md-1 px-md-1"
                >
                  <a
                    class="col btn btn-danger btn-sm mt-4"
                    @click="excluirItemArray(index)"
                  >
                    <i class="col mdi mdi-close px-0"></i>
                  </a>
                </div>

                <div v-else class="col-sm-12 col-md-1 px-md-1">
                  <a
                    class="col btn btn-success btn-sm mt-4"
                    @click="adicionarItemArray"
                  >
                    <i class="col mdi mdi-plus px-0"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="row pt-4 px-0 d-flex justify-content-end">
            <div class="col-auto px-2 text-right">
              <a
                class="router-link-exact-active active px-3"
                @click="historicoStatus = true"
              >
                <i class="fas fa-history"></i>
                Histórico de Status
              </a>

              <a class="btn btn-default" @click="listBeneficios">
                <i class="mdi mdi-arrow-left" />
              </a>

              <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                type="button"
                @click="submit"
              >
                <i class="mdi mdi-content-save" />
                {{ $t("Salvar") }}
              </button>
            </div>
          </div>
        </div>

        <div v-else class="card-body">
          <h4 class="h3 mb-3 text-gray-800">
            {{ $t("Histórico Benefício") }}
          </h4>

          <div class="row">
            <HistoricoStatus
              :id="beneficio.id"
              :familia="beneficio.familia_id"
              @voltar="historicoStatus = false"
            />
          </div>
        </div>
      </div>

      <status-historico
        modulo="Beneficio"
        model="Beneficio"
        titulo_modulo="BENEFICIO"
        :id="beneficio.id"
        :status-anterior="statusAnterior"
        :status-atual="statusAtual"
        :status="status_item"
        @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import HistoricoStatus from "./HistoricoStatus";

export default {
  components: {
    HistoricoStatus,
  },

  name: "Edit",

  data() {
    return {
      historicoStatus: false,
      status_item: [],
      beneficio: "",
      item_nome: [],
      item_quantidade: [],
      item_dimensoes: [],
      item_peso: [],
      item_validade: [],
      count: 1,
      tipos: [],
      subtipos: [],
      status_beneficio: [],
      unidades: [],
      loading: true,
      edit: true,
      statusAtual: "",
      statusAnterior: "",
      mostrarValor: false,
    };
  },

  mounted() {
    this.getTipos();
    this.getStatus();
    this.getUnidades();
    this.getStatusFinais();
  },

  watch: {
    "beneficio.categoria"(novaCategoria) {
      this.mostrarValor = Number(novaCategoria) === 1;

      if (Number(novaCategoria) !== 1) {
        this.beneficio.valor = null;
      }
    },

    "beneficio.is_itens"(possuiItens) {
      if (Number(possuiItens) !== 1) {
        this.limparItensNovos();
      }
    },
  },

  methods: {
    formatarValor() {
      if (this.beneficio.valor === null || this.beneficio.valor === undefined) {
        return;
      }

      let valor = String(this.beneficio.valor).replace(/\D/g, "");

      if (valor.length > 2) {
        valor = valor.replace(/(\d)(\d{2})$/, "$1,$2");
      }

      if (valor.length > 6) {
        valor = valor.replace(/(\d)(\d{3})(\d{3})$/, "$1.$2.$3");
      }

      this.beneficio.valor = valor;
    },

    carregarValorDoBanco(valor) {
      if (valor === null || valor === undefined || valor === "") {
        return "";
      }

      let formattedValue = valor.toString().trim();

      if (formattedValue.includes(",") || formattedValue.includes(".")) {
        formattedValue = formattedValue.replace(/\D/g, "");

        if (formattedValue.length > 2) {
          formattedValue = formattedValue.replace(/(\d)(\d{2})$/, "$1,$2");
        }

        if (formattedValue.length > 6) {
          formattedValue = formattedValue.replace(
            /(\d)(\d{3})(\d{3})$/,
            "$1.$2.$3"
          );
        }
      } else {
        formattedValue = formattedValue.replace(/\D/g, "") + ",00";
      }

      return formattedValue;
    },

    formatarParaSubmit(valorFormatado) {
      if (
        valorFormatado === null ||
        valorFormatado === undefined ||
        valorFormatado === ""
      ) {
        return null;
      }

      return String(valorFormatado).replace(/\./g, "").replace(",", ".");
    },

    verificarStatus(status) {
      this.statusAtual = status;

      const result = this.status_item.filter((item) => item.id == status);

      if (result.length > 0 && result[0].final == 1) {
        this.$bvModal.show("status-historico-Beneficio");
      }
    },

    getStatusFinais() {
      axios
        .post("api/dashboard/get/status/finais", {
          model: "Beneficio",
          module: "Beneficio",
        })
        .then((response) => {
          this.status_item = response.data;
        });
    },

    getBeneficio() {
      const id = this.$route.params.id;

      this.loading = true;

      axios
        .get(`api/dashboard/get/beneficio/${id}`)
        .then((response) => {
          this.beneficio = response.data.data;
          this.statusAnterior = this.beneficio.status;

          if (!Array.isArray(this.beneficio.itens)) {
            this.$set(this.beneficio, "itens", []);
          }

          this.beneficio.valor = this.carregarValorDoBanco(
            this.beneficio.valor
          );

          if (this.beneficio.liberados_qtd > 0) {
            this.edit = false;
          }

          this.getSubTipos();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getTipos() {
      axios.get("api/dashboard/get/beneficios/tipos").then((response) => {
        this.tipos = response.data;
      });
    },

    getSubTipos(tipoAlterado) {
      this.subtipos = [];

      if (tipoAlterado !== undefined) {
        this.beneficio.subtipo_id = null;
      }

      if (!this.beneficio || !this.beneficio.tipo_id) {
        return;
      }

      axios
        .get(`api/dashboard/get/beneficios/subtipos/${this.beneficio.tipo_id}`)
        .then((response) => {
          this.subtipos = response.data;
        });
    },

    getStatus() {
      axios.get("api/dashboard/get/beneficios/status").then((response) => {
        this.status_beneficio = response.data;
      });
    },

    getUnidades() {
      axios
        .get("api/dashboard/unidades/get/externas")
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.getBeneficio();
        });
    },

    excluirItem(item) {
      axios
        .get(`api/dashboard/beneficio/delete/itens/${item.id}`)
        .then((response) => {
          this.beneficio.itens = response.data;
        });
    },

    adicionarItemArray() {
      this.count++;
    },

    excluirItemArray(index) {
      if (index < 0 || index >= this.count) {
        return;
      }

      this.item_nome.splice(index, 1);
      this.item_quantidade.splice(index, 1);
      this.item_dimensoes.splice(index, 1);
      this.item_peso.splice(index, 1);
      this.item_validade.splice(index, 1);

      if (this.count > 1) {
        this.count--;
      }
    },

    limparItensNovos() {
      this.item_nome = [];
      this.item_quantidade = [];
      this.item_dimensoes = [];
      this.item_peso = [];
      this.item_validade = [];
      this.count = 1;

      if (this.beneficio && typeof this.beneficio === "object") {
        this.$set(this.beneficio, "itens_novos", {
          nome: [],
          quantidade: [],
          dimensoes: [],
          peso: [],
          validade: [],
        });
      }
    },

    montarItensNovos() {
      if (Number(this.beneficio.is_itens) !== 1) {
        return {
          nome: [],
          quantidade: [],
          dimensoes: [],
          peso: [],
          validade: [],
        };
      }

      return {
        nome: [...this.item_nome],
        quantidade: [...this.item_quantidade],
        dimensoes: [...this.item_dimensoes],
        peso: [...this.item_peso],
        validade: [...this.item_validade],
      };
    },

    submit() {
      this.$set(this.beneficio, "itens_novos", this.montarItensNovos());

      if (Number(this.beneficio.categoria) === 2) {
        this.beneficio.valor = null;
      }

      if (Number(this.beneficio.categoria) !== 2) {
        this.beneficio.valor = this.formatarParaSubmit(this.beneficio.valor);
      }

      const botaoSubmit = document.querySelector(".btn-submit");

      const ladda = Ladda.create(botaoSubmit);

      ladda.start();

      axios
        .post("api/dashboard/beneficio/update", this.beneficio)
        .then((response) => {
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });

          if (this.morph !== undefined) {
            this.$emit("reload");
          } else {
            this.$router.push(
              `/dashboard/beneficio/edit/${response.data.data.id}`
            );
          }
        })
        .finally(() => {
          ladda.stop();
          this.files = [];
        });
    },

    listBeneficios() {
      this.$router.push({
        path: "/dashboard/beneficios",
      });
    },
  },
};
</script>
